import { apiGet, apiSend, apiDelete } from './httpClient'
import type { Expense, ExpenseSummary, CreateExpenseInput } from './types'

export function listExpensesHttp(tripId: string): Promise<Expense[]> {
  return apiGet<Expense[]>(`/trips/${tripId}/expenses`)
}

export function getSummaryHttp(tripId: string): Promise<ExpenseSummary> {
  return apiGet<ExpenseSummary>(`/trips/${tripId}/expenses/summary`)
}

export function createExpenseHttp(tripId: string, input: CreateExpenseInput): Promise<Expense> {
  return apiSend<Expense>('POST', `/trips/${tripId}/expenses`, input)
}

export function updateExpenseHttp(
  tripId: string,
  expId: string,
  input: Partial<CreateExpenseInput>,
): Promise<Expense> {
  return apiSend<Expense>('PATCH', `/trips/${tripId}/expenses/${expId}`, input)
}

export function deleteExpenseHttp(tripId: string, expId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/expenses/${expId}`)
}
